import { render, staticRenderFns } from "./FormInputCheckbox.vue?vue&type=template&id=1fc87b32&scoped=true&"
import script from "./FormInputCheckbox.vue?vue&type=script&lang=ts&"
export * from "./FormInputCheckbox.vue?vue&type=script&lang=ts&"
import style0 from "./FormInputCheckbox.vue?vue&type=style&index=0&id=1fc87b32&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc87b32",
  null
  
)

export default component.exports